module.exports = __webpack_public_path__ + "assets/img/T8-mz501.0733a437.jpg";